import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { EmailUnsubPage } from "@/pages/EmailUnsub/EmailUnsubPage";

export function WebRouter() {
  return (
    <Routes>
      <Route path={"email-unsub"} element={<EmailUnsubPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
